import React from "react";
import { IndexRoute, Route } from "react-router";
import { DELETE_PAGE_CONTENT } from "../../shared/constants/appConstants";
import ErrorPageContainer from "../../shared/containers/errorPage/errorPageContainer";
import UnitAwareContainer from "../../shared/containers/unit/unitAwareContainer";
import SectionContainer from "../../shared/containers/roomBook/sectionContainer";
import LineItemPage from "../../shared/components/roomBook/LineItemPage";
import SubLineItemPage from "../../shared/components/roomBook/SubLineItemPage";
import ImprintContainer from "../../shared/containers/pages/imprintContainer";
import { browserHistory } from "../../shared/routes/browserHistory";
import PageLayoutContainer from "../containers/pageLayoutContainer";
import AttachmentContainer from "../../buyer_portal/containers/attachment/attachmentContainer";
import Unit from "../../shared/components/unit/Unit";

let lastState = {
  routes: {},
  params: {},
  location: {}
};

const Routes = dispatch => {
  const _handleRedirects = () => {
    if (window.location.pathname === "/") {
      browserHistory.push("/dashboard"); // redirect / to /projects
      return true;
    }
    return false;
  };

  const onlyTabChanged = (nextState, lastState) => {
    if (
      lastState.params.tab &&
      nextState.params.tab &&
      lastState.params.tab === nextState.params.tab
    ) {
      return false;
    }
    if (
      String(lastState.location.pathname).replace(
        `/${String(lastState.params.tab)}`,
        ""
      ) ===
      String(nextState.location.pathname).replace(
        `/${String(nextState.params.tab)}`,
        ""
      )
    ) {
      return true;
    }
    return false;
  };

  const resetPageContentState = nextState => {
    if (onlyTabChanged(nextState, lastState)) {
      lastState = nextState;
      return;
    }
    lastState = nextState;
    if (!_handleRedirects()) {
      dispatch({
        type: DELETE_PAGE_CONTENT
      });
    }
  };

  return (
    <Route>
      <Route
        name="buyerPortal.label.one"
        title="buyerPortal.label.one"
        path="react_router"
        component={PageLayoutContainer}
      >
        <Route
          layoutScope="unit"
          name="buyerPortal.menu.products"
          title="buyerPortal.menu.products"
          path="/:projectId/musterwohnung(/:id)"
          component={UnitAwareContainer}
          onEnter={resetPageContentState}
        >
          <IndexRoute
            layoutScope="unit"
            name="buyerPortal.menu.products"
            title="buyerPortal.menu.products"
            component={Unit}
          />
          <Route
            layoutScope="unit"
            path="section/:sectionId"
            name="buyerPortal.menu.products"
            title="buyerPortal.menu.products"
            component={SectionContainer}
          />
          <Route
            layoutScope="unit"
            path="section/:sectionId/line_item/:lineItemId"
            name="buyerPortal.menu.products"
            title="buyerPortal.menu.products"
            component={LineItemPage}
          />
          <Route
            layoutScope="unit"
            path="section/:sectionId/line_item/:lineItemId/sub_line_item/:subLineItemId"
            name="buyerPortal.menu.products"
            title="buyerPortal.menu.products"
            component={SubLineItemPage}
          />
          <Route
            layoutScope="unit"
            path="attachment"
            name="buyerPortal.menu.attachments"
            title="buyerPortal.menu.attachments"
            component={AttachmentContainer}
          />
        </Route>
        <Route
          layoutScope="imprint"
          path="/imprint"
          name="buyerPortal.menu.imprint"
          component={ImprintContainer}
        />
        <Route
          layoutScope="error"
          path="/*"
          name="error"
          component={ErrorPageContainer}
        />
      </Route>
    </Route>
  );
};

export default Routes;
